import { render, staticRenderFns } from "./CurrentDiscussion.vue?vue&type=template&id=2b90cf14&"
import script from "./CurrentDiscussion.vue?vue&type=script&lang=js&"
export * from "./CurrentDiscussion.vue?vue&type=script&lang=js&"
import style0 from "./CurrentDiscussion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CurrentDiscussion.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/gutters/CurrentDiscussion.vue
// module id = 2234
// module chunks = 1